// ./src/utils/planTrial.ts
//
// ROADMAP #238 — what a draft (or a test run) may try of a BACK-OFFICE tool: a MIRROR of eventsmagic-api
// `src/boundary/planTrial.ts` (`npm run check-entitlement` asserts the two agree). Owner, 2026-10-28: budget, vendors,
// rentals, purchase orders, QR tags and inventory are tried with a SAMPLE of 3 per tool per event, kept, and never stop
// publishing; volunteer shifts are a sample AND asked at publishing; reports are viewed on a draft, never exported or
// printed there. The SERVER enforces every one of these; this only decides what to draw.
// ⚠ Pure, so `check-entitlement` runs it.

/** Records a draft or a test run may make of a back-office tool before the plan is asked. */
export const PLAN_TRIAL_SAMPLE = 3;

/**
 * How a page's feature is tried on a draft: `sample` — up to `PLAN_TRIAL_SAMPLE`, never asked at publishing (back-office);
 * `both` — up to `PLAN_TRIAL_SAMPLE`, and publishing asks (volunteer shifts). Absent = tried freely, publishing asks (#231).
 */
export type PlanTrialKind = "sample" | "both";

/** May `adding` more be made while `count` already exist? */
export const planSampleAllows = (count: number | null | undefined, adding: number = 1): boolean =>
  Math.max(0, Number(count) || 0) + Math.max(1, Math.floor(Number(adding) || 1)) <= PLAN_TRIAL_SAMPLE;

/** The refusal past the sample — word for word the server's. */
export const planSampleRefusal = (featureName: string, noun: readonly [string, string]): string =>
  `${featureName}: a draft or a test run can try up to ${PLAN_TRIAL_SAMPLE} ${noun[1]}. Upgrade to add more.`;
